const PaymentCardBrands = {
    visa: 'Visa',
    mastercard: 'MasterCard',
    amex: 'American Express',
    discovery: 'Discover',
    maestro: 'Maestro',
    solo: 'Solo',
    electron: 'Electron',
    jcb: 'JCB',
    voyager: 'Voyager',
    dinersClub: 'Diners Club',
    switch: 'Switch',
    laser: 'Laser',
    chinaUnionPay: 'China UnionPay',
    astroPayCard: 'AstroPay Card',
    // fuel: 'Fuel Credit Card', TODO check if it still exists
};

export default PaymentCardBrands;

export const PAYMENT_CARD_BRANDS_LIST = Object.values(PaymentCardBrands)
    .map(label => ({label, value: label}));
